import api from "./axiosSetup"
import swal from 'sweetalert'
import getCodeFromUrl from "../utilities/code";

const urlCode = getCodeFromUrl();


const getInstallmentDetails = async (setState) => {
    try{
        const res = await api.get(`/installment/${urlCode}`)
        setState(res.data)
    }
    catch(error){
        swal({
            title: "عملیات ناموفق",
            text: error.response?.data.message,
            icon: "error",
            button: "متوجه شدم"
          });
    }
}
export default getInstallmentDetails;